import { useEffect } from 'react';
import moment from 'moment';

export const usePickerValueChange = (
    setLocalValue: (value: Date | null) => void,
    localValue: Date | null,
    value?: Date | null,
    setPrefix?: (prefix:string) => void) => {

    useEffect(() => {
        if (isEqual()) return;
        
        if (moment.isMoment(value)) {
            setLocalValue(value.toDate());
            if(setPrefix)
                setPrefix(value.format("DD.MM"));
        } else if(value) {
            const date = moment(value);
            if (date.isValid()) {                
                setLocalValue(date.toDate());
                if(setPrefix)
                    setPrefix(date.format("DD.MM"));
            } 
        } else {

            setLocalValue(null);
        }
    }, [value]);

    function isEqual() {
        const format = "YYYY-MM-DDTHH:mm:ss";

        let localString = "";
        let valueString = "";

        if (localValue) {
            localString = moment(localValue).format(format);
        }

        if (moment.isMoment(value)) {
            valueString = value.format(format);
        } else {
            const date = moment(value);
            if (date.isValid()) {
                valueString = date.format(format);
            }
        }

        return localString === valueString;
    }
};
